import { useState } from 'react'
import { useMemoizedFn } from 'ahooks'
import {
    DOUYIN_PLATFORM_KEY,
    KUAISHOU_PLATFORM_KEY,
    TAOBAO_PLATFORM_KEY,
    PDD_PLATFORM_KEY,
    JD_PLATFORM_KEY,
    TIANMAO_PLATFORM_KEY
} from '@/modules/globals/constants/platform/basics'
import dyImageValidate from '@/components/GoodsQuickShelf/DyShelf/validate/imageValidate'
import pddImageValidate from '@/components/GoodsQuickShelf/PbbShelf/validate/imageValidate'
import ksImageValidate from '@/components/GoodsQuickShelf/KsShelf/validate/imageValidate'
import tbImageValidate from '@/components/GoodsQuickShelf/TbNewShelf/validate/imageValidate'
import tmImageValidate from '@/components/GoodsQuickShelf/TmShelf/validate/imageValidate'
import jdImageValidate from '@/components/GoodsQuickShelf/JdShelf/validate/imageValidate'
import {
    transImagesErrors,
    transReplaceErrors,
    transRectRatioReplaceImages,
    replacePicToGoodsSku,
    replacePicToValue,
    REPLACE_IMAGE_RECT_RATIO
} from '@/modules/goods/basics/features/imagesReplace/helper'
import { FIELD_GOODS_SKU } from '@/modules/globals/constants/platform/fieldNames'
import { DEFAULT_COLOUR_ID } from '@/components/GoodsQuickShelf/JdShelf/constants'
import { imageResize } from '@/services/goods'
import groupBy from 'lodash/groupBy'
import MD5 from 'crypto-js/md5'

const imageValidateMap = {
    [DOUYIN_PLATFORM_KEY]: dyImageValidate,
    [PDD_PLATFORM_KEY]: pddImageValidate,
    [KUAISHOU_PLATFORM_KEY]: ksImageValidate,
    [TAOBAO_PLATFORM_KEY]: tbImageValidate,
    [JD_PLATFORM_KEY]: jdImageValidate,
    [TIANMAO_PLATFORM_KEY]: tmImageValidate
}

const gainFieldDataToPics = ({ name, data, platformKey }) => {
    if (platformKey === JD_PLATFORM_KEY) {
        // 京东有特殊的图片格式
        const images = Array.isArray(data?.images) ? data?.images : []
        switch (name) {
            case jdImageValidate.displayImagesMain.name: {
                const mainImage = images.find(item => item?.colorId === DEFAULT_COLOUR_ID)

                console.log('replaceErrorList-2', {
                    name,
                    data,
                    platformKey
                })

                return Array.isArray(mainImage?.displayImages) ? mainImage?.displayImages : []
            }
            case jdImageValidate.displayImages.name: {
                const displayImage = images.filter(item => item?.colorId !== DEFAULT_COLOUR_ID)
                return displayImage.reduce((list, item) => {
                    return list.concat(Array.isArray(item?.displayImages) ? item?.displayImages : [])
                }, [])
            }
            case jdImageValidate.transparentImageUrl.name: {
                return images.reduce((list, item) => {
                    if (item?.transparentImageUrl) {
                        return list.concat(item?.transparentImageUrl)
                    }
                    return list
                }, [])
            }
            case jdImageValidate.whiteImageUrl.name: {
                return images.reduce((list, item) => {
                    if (item?.whiteImageUrl) {
                        return list.concat(item?.whiteImageUrl)
                    }
                    return list
                }, [])
            }
            default:
                return []
        }
    }

    if (name === FIELD_GOODS_SKU) {
        const goodsSku = data[FIELD_GOODS_SKU]
        return goodsSku?.[0]?.value?.map(item => item?.pic) || []
    }

    return data[name]
}

const replaceListAddName = ({ replaceErrorList, replaceList }) => {
    return replaceList.map(item => {
        const replaceErrorItem = replaceErrorList.find(item2 => item2.url === item.oldUrl)

        return {
            ...item,
            name: replaceErrorItem?.name
        }
    })
}

const getReplaceJdPicData = ({ groupReplaceList, form, data }) => {
    const images = data?.images || form.getFieldValue('images')

    for (const key in groupReplaceList) {
        if (groupReplaceList.hasOwnProperty(key)) {
            const newPics = groupReplaceList[key]
            switch (key) {
                case jdImageValidate.displayImagesMain.name: {
                    const mainImage = images.find(item => item?.colorId === DEFAULT_COLOUR_ID)
                    mainImage.displayImages = replacePicToValue({ value: mainImage.displayImages, newPics })
                    break
                }
                case jdImageValidate.displayImages.name: {
                    const displayImage = images.filter(item => item?.colorId !== DEFAULT_COLOUR_ID)
                    displayImage.forEach(item => {
                        item.displayImages = replacePicToValue({ value: item.displayImages, newPics })
                    })
                    break
                }
                case jdImageValidate.transparentImageUrl.name: {
                    images.forEach(item => {
                        item.transparentImageUrl = replacePicToValue({ value: item?.transparentImageUrl, newPics })
                    })
                    break
                }
                case jdImageValidate.whiteImageUrl.name: {
                    images.forEach(item => {
                        item.whiteImageUrl = replacePicToValue({ value: item?.whiteImageUrl, newPics })
                    })
                    break
                }
                default:
                    return []
            }
        }
    }

    return {
        images
    }
}

const getReplacePicData = ({ groupReplaceList, platformKey, form, data }) => {
    if (platformKey === JD_PLATFORM_KEY) {
        return getReplaceJdPicData({ groupReplaceList, form, data })
    }

    const newData = {}
    for (const key in groupReplaceList) {
        if (groupReplaceList.hasOwnProperty(key)) {
            const value = form.getFieldValue(key)
            const newPics = groupReplaceList[key]
            const newValue =
                key === FIELD_GOODS_SKU
                    ? replacePicToGoodsSku({
                          value,
                          newPics
                      })
                    : replacePicToValue({ value, newPics })

            newData[key] = newValue
        }
    }

    return newData
}

class CacheReplaceImages {
    cache = {}

    key({ replaceErrorList }) {
        return MD5(JSON.stringify(replaceErrorList)).toString()
    }

    save({ replaceErrorList, replaceList }) {
        const key = this.key({ replaceErrorList })

        this.cache[key] = replaceList
        return false
    }

    get({ replaceErrorList }) {
        const key = this.key({ replaceErrorList })

        if (this.cache[key]) {
            return this.cache[key]
        }

        return false
    }
}

const cacheReplaceImages = new CacheReplaceImages()

export default () => {
    const [loading, setLoading] = useState(false)

    // 替换图片
    const replaceDataImage = ({ groupReplaceList, platformKey, form, data }) => {
        const replaceData = getReplacePicData({ groupReplaceList, platformKey, form, data })
        form && form.setFieldsValue(replaceData)
    }

    const dataReplacePic = async ({ platformKey, newAutoResizeImageList, data }) => {
        const imageValidate = imageValidateMap[platformKey]
        const imageValidateFields = newAutoResizeImageList
            .map(name => {
                return imageValidate[name]
            })
            .filter(item => item)

        // console.log('autoResizeImage-imageValidateFields', {
        //     imageValidateFields
        // })

        if (imageValidateFields.length === 0) {
            return
        }

        const replaceErrorList = imageValidateFields.reduce((list, { name, validate }) => {
            const value = gainFieldDataToPics({ name, data, platformKey })
            const imagesErrors = transImagesErrors({ value, singleValidate: validate })
            const replaceErrors = transReplaceErrors(imagesErrors)[REPLACE_IMAGE_RECT_RATIO]
            const replaceImages = transRectRatioReplaceImages({
                name,
                singleValidate: validate,
                replaceErrors
            })

            return list.concat(replaceImages)
        }, [])

        // console.log('autoResizeImage-replaceErrorList', {
        //     replaceErrorList
        // })

        const cacheReplaceList = cacheReplaceImages.get({ replaceErrorList })

        if (cacheReplaceList) {
            return cacheReplaceList
        }

        setLoading(true)

        const imageHandlerJson = await imageResize(
            replaceErrorList.map(({ styleType, url }) => ({
                styleType,
                url
            }))
        )

        if (imageHandlerJson?.success) {
            const replaceList = imageHandlerJson?.data
            if (Array.isArray(replaceList) && replaceList.length > 0) {
                const newReplaceList = replaceListAddName({ replaceErrorList, replaceList })
                const groupReplaceList = groupBy(newReplaceList, item => item.name)

                cacheReplaceImages.save({ replaceErrorList, replaceList: groupReplaceList })

                return groupReplaceList
            }
        }
    }

    // 切换类目判断类目是否切换过处理
    const changeCategory = useMemoizedFn(async ({ form, platformKey, data, autoResizeImageList }) => {
        try {
            if (!Array.isArray(autoResizeImageList)) {
                return
            }

            const newAutoResizeImageList = autoResizeImageList.filter(item => item === FIELD_GOODS_SKU)

            if (newAutoResizeImageList.length === 0) {
                return
            }

            const groupReplaceList = await dataReplacePic({ platformKey, newAutoResizeImageList, data })

            replaceDataImage({
                groupReplaceList,
                platformKey,
                form,
                data
            })

            setLoading(false)
        } catch (error) {
            console.error('类目切换自动', error)
            setLoading(false)
        }
    })

    // excludeGoodsSku 排查规格，根据编辑进入页面，规格是否根据类目展示
    const autoResizeImage = useMemoizedFn(
        async ({ form, platformKey, data, autoResizeImageList, excludeGoodsSku = false }) => {
            try {
                if (!Array.isArray(autoResizeImageList)) {
                    return
                }

                let newAutoResizeImageList = autoResizeImageList

                if (excludeGoodsSku) {
                    newAutoResizeImageList = newAutoResizeImageList.filter(item => item !== FIELD_GOODS_SKU)
                }

                if (newAutoResizeImageList.length === 0) {
                    return
                }

                const groupReplaceList = await dataReplacePic({ platformKey, newAutoResizeImageList, data })

                console.log('autoResizeImage-groupReplaceList', {
                    groupReplaceList
                })

                replaceDataImage({
                    groupReplaceList,
                    platformKey,
                    form,
                    data
                })

                setLoading(false)
            } catch (error) {
                console.error('自动处理图片失败', error)
                setLoading(false)
            }
        }
    )

    return {
        loading,
        changeCategory,
        autoResizeImage
    }
}
